import React, { useState, useEffect } from "react";

const ImageSlider = ({ imageList, rounded }) => {
  const [currentImage, setCurrentImage] = useState(0);

  const imageSliderStyle = {
    backgroundImage:
      imageList && imageList.length > 0
        ? `url(${imageList[currentImage]})`
        : "url(https://placehold.co/890x1024?text=No+Image)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: "100%",
    width: "100%",
    borderRadius: rounded ? "0.5rem" : "0",
    transition: "background-image 1s ease-in-out",
  };

  useEffect(() => {
    if (imageList?.length > 1) {
      const interval = setInterval(() => {
        setCurrentImage((prev) => {
          if (prev + 1 < imageList?.length) {
            return prev + 1;
          } else {
            return 0;
          }
        });
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [imageList, currentImage]);

  return (
    <div className="w-full h-full">
      <div style={imageSliderStyle}></div>
    </div>
  );
};

export default ImageSlider;
